import { theme } from '@carto/meridian-ds/theme'
import { Box, styled } from '@mui/material'

type Props = {
  divider?: boolean
}

export const Container = styled(Box)<Props>(({ divider = true }) => ({
  padding: theme.spacing(3, 0, 3.125, 0),
  borderBottom: divider ? `1px solid ${theme.palette.divider}` : 'none'
}))
